import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {isEmpty, pick} from 'lodash';
import classnames from 'classnames';
import i18n from 'i18n';

import {changeLanguage} from 'redux/modules/app';

import styles from './LoginSupportLinks.less';

function mapStateToProps({app}) {
  return pick(app, ['currentLanguage', 'availableLanguages']);
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({changeLanguage}, dispatch);
}

class LoginSupportLinks extends Component {
  render = () => {
    const {changeLanguage, currentLanguage, availableLanguages} = this.props;

    const languages = availableLanguages.map((locale) => {
      const className = classnames('padding-horizontal-Hx', styles.language, {
        [styles.selected]: locale.code === currentLanguage
      });

      return (
        <div
          key ={locale.code} 
          className={className}
          onClick={() => changeLanguage(locale.code)}
        >
          {locale.code.toUpperCase()}
        </div>
      );
    });

    return (
      <div className={`flex end-xs between-md ${styles.container}`}>
        <div className='hide-xs'>
          <div className='flex padding-left-2x width80'>
            <a target='_blank' href={i18n.get('LOGIN_SUPPORT_LINKS_HELP_URL')}>
              {i18n.get('LOGIN_SUPPORT_LINKS_HELP')}
            </a>
            <a target='_blank' href='https://voxfeed.com/terms'>
              {i18n.get('LOGIN_SUPPORT_LINKS_TOS')}
            </a>
            <a target='_blank' href='https://voxfeed.com/privacy'>
              {i18n.get('LOGIN_SUPPORT_LINKS_PRIVACY')}
            </a>
            <a target='_blank' href='https://voxfeed.com/contact'>
              {i18n.get('LOGIN_SUPPORT_LINKS_CONTACT')}
            </a>
          </div>
        </div>

        <div className='padding-right-2x flex'>
          {!!availableLanguages.length && languages}
        </div>
      </div>
    );
  }
}

LoginSupportLinks.propTypes = {
  currentLanguage: PropTypes.string.isRequired,
  availableLanguages: PropTypes.array.isRequired,
  changeLanguage: PropTypes.func.isRequired
};

LoginSupportLinks.defaultProps = {
  currentLanguage: '',
  availableLanguages: [],
  changeLanguage: () => {}
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginSupportLinks);
